import { render, staticRenderFns } from "./form-vm.vue?vue&type=template&id=6b35dbe8&"
import script from "./form-vm.vue?vue&type=script&lang=js&"
export * from "./form-vm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports